import SearchField from '@pelckmans/elementis/components/search-field';
import debounce from 'lodash/debounce';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

function AdvancedSearchField() {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const searchQuery = searchParams.get('q')?.trim() || '';
  const [searchText, setSearchText] = React.useState<string>(searchQuery);

  const handleClear = () => {
    setSearchText('');
    setSearchParams({});
  };

  const debouncedUpdateSearchParams = useMemo(
    () =>
      debounce((value: string) => {
        setSearchParams({ q: value.trim() });
      }, 500),
    [setSearchParams],
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchText(value);

    if (value.trim() === '') {
      debouncedUpdateSearchParams.cancel();
      setSearchParams(prev => {
        const newParams = new URLSearchParams(prev);
        newParams.delete('q');
        return newParams;
      });
      return;
    }

    debouncedUpdateSearchParams(value);
  };

  return (
    <SearchField
      value={searchText}
      placeholder={t('PAGES.SEARCH.HEADER.SEARCH_FIELD.PLACEHOLDER')}
      searchActionLabel={t('PAGES.SEARCH.HEADER.SEARCH_FIELD.SEARCH_ACTION_LABEL')}
      clearActionLabel={t('PAGES.SEARCH.HEADER.SEARCH_FIELD.CLEAR_ACTION_LABEL')}
      onChange={handleChange}
      onClear={handleClear}
      onSearch={() => setSearchParams({ q: searchText })}
    />
  );
}

export default AdvancedSearchField;
